<template>
  <div class="find-us">
    <div class="margin-general container">
      <div class="title">
        <h3 class="heading-h3">{{ $t(findus.title) }}</h3>
        <!-- <p class="body-4">{{ $t(findus.description) }}</p> -->
      </div>
      <div class="cont-card">
        <div
          :key="euInfo.id"
          class="card-find"
          :class="{ 'has-iframe': euInfo.iframe }"
        >
          <div class="text-cont">
            <p class="body-6-bold">{{ $t(euInfo.title) }}</p>
            <p class="body-4">
              {{ $t(euInfo.country) }} <br />
              {{ $t(euInfo.countrybr) }}
            </p>
            <p class="body-4">
              <strong>{{ $t(findus.Headquartersstrong) }}</strong>
              {{ $t(euInfo.headquarters) }}
            </p>
            <p class="body-4">
              <strong>{{ $t(findus.websitestrong) }}</strong>
              <a :href="euInfo.link" target="_blank" class="link-4" rel="noopener noreferrer">
                {{ euInfo.nameLink }}
              </a>
            </p>
          </div>
          <!-- Aquí agregamos la opción del iframe -->
          <div v-if="euInfo.iframe" class="cont-location">
            <iframe
              :src="euInfo.iframe"
              width="100%"
              height="100%"
              style="border:0;"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
        <div class="links">
          <p v-html="formatContent(findus.linkstexts, $t)"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>


const euInfo = {
  id: 1,
  title: "findus.titlecard1",
  country: "findus.country1",
  countrybr: "findus.countrybr1",
  headquarters: "findus.Headquarters1",
  nameLink: "www.tradeview.eu",
  link: "https://tradeview.eu/",
  iframe: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12926.132990737991!2d14.5061212!3d35.9094456!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x130e45dc7de8b5f5%3A0xc54d65b06e4e914a!2sTradeview%20Europe%20Ltd.!5e0!3m2!1sen!2sco!4v1726591664564!5m2!1sen!2sco",
};

const findus = {
  title: "findus.title",
  description: "findus.description",
  Headquartersstrong: "findus.Headquartersstrong",
  websitestrong: "findus.websitestrong",
  cards: [
    /* {
      id: 3,
      title: "findus.titlecard3",
      country: "findus.country3",
      countrybr: "findus.countrybr3",
      headquarters: "findus.Headquarters3",
      nameLink: "www.tvmarkets.com",
      link: "https://www.tvmarkets.com",
      iframe: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15063.041040809754!2d-81.3850922!3d19.2927891!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f25868ab9afffff%3A0xd1dc532e0dd1c91f!2sTradeview%20Markets!5e0!3m2!1sen!2sco!4v1726591291167!5m2!1sen!2sco",
    },
    {
      id: 4,
      title: "findus.titlecard4",
      country: "findus.country4",
      countrybr: "findus.countrybr4",
      headquarters: "findus.Headquarters4",
      nameLink: "www.tradeviewlatam.com",
      link: "https://www.tvmarkets.com",
    },
    {
      id: 5,
      title: "findus.titlecard5",
      country: "findus.country5",
      countrybr: "findus.countrybr5",
      headquarters: "findus.Headquarters5",
      nameLink: "www.tvmgloballtd.com",
      link: "https://www.tvmgloballtd.com",
    },
    {
      id: 6,
      title: "findus.titlecard6",
      country: "findus.country6",
      countrybr: "findus.countrybr6",
      headquarters: "findus.Headquarters6",
      nameLink: "www.ilcbrokers.com",
      link: "https://www.ilcbrokers.com",
    }, */
  ],
  linkstexts: "findus.linkstext",
};
</script>